<template>
  <div id="app">
    <h1>Unilever ภาษีป้าย</h1>
    <!-- Show Login or UploadForm based on loggedIn -->
    <LoginForm v-if="!loggedIn" @login-success="handleLoginSuccess" />
    <UploadForm v-else />
  </div>
</template>

<script>
import LoginForm from './components/LoginForm.vue';
import UploadForm from './components/UploadForm.vue';

export default {
  name: 'App',
  components: {
    LoginForm,
    UploadForm,
  },
  data() {
    return {
      loggedIn: false, // Tracks whether the user is logged in
    };
  },
  methods: {
    handleLoginSuccess() {
      this.loggedIn = true; // Switch to UploadForm after login
    },
  },
};
</script>

<style>
/* Add global styles here if needed */
</style>
